export const Languages = [
  {
    id: 'en',
    name: 'English',
    img: 'usa.png',
    available: true,
  },
  {
    id: 'fr',
    name: 'French',
    img: 'fr.png',
    available: false,
  },
  {
    id: 'es',
    name: 'Spanish',
    img: 'sp.png',
    available: false,
  },
];

export interface Language {
  id: string;
  name: string;
  img: string;
  available: boolean;
}
